import { map } from 'lodash-es';
import { jsonResponseHandling } from '../fetch';
import { getViewPermission } from '../helpers';
import { fetchWithAuthHeader } from '../../auth';
import HTTP_TYPES from '../../types/http-types';
import { buildDisruptionsQuery } from '../control/disruptions';
import { apiUrl, DISRUPTION_MANAGEMENT_PATH } from '../api-manager';

const { GET, POST, PUT, DELETE } = HTTP_TYPES;

const appendIncludeFilteredRoutes = (url, includeFilteredRoutes = false) => {
    if (!includeFilteredRoutes) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}include_filtered_routes=true`;
};

export const getDisruptionsViewPermission = () => getViewPermission(apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/view`));

export const getDisruptions = (includeDrafts = false, includeFilteredRoutes = true) => fetchWithAuthHeader(
    appendIncludeFilteredRoutes(apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions?includeDraft=${includeDrafts}`), includeFilteredRoutes),
    { method: GET },
)
    .then(response => jsonResponseHandling(response));

export const getDisruption = (disruptionId, signal) => fetchWithAuthHeader(apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions/${disruptionId}`), { method: GET, signal })
    .then(response => jsonResponseHandling(response));

export const getDiversion = (disruptionId) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/diversions/?disruptionId=${disruptionId}`);
    return fetchWithAuthHeader(
        url,
        {
            method: GET,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response));
};

export const deleteDiversion = (id) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/diversions/${id}`);
    return fetchWithAuthHeader(url, {
        method: DELETE,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then(response => jsonResponseHandling(response));
};

export const updateDisruption = (disruption) => {
    const { disruptionId } = disruption;
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions/${disruptionId}`);
    return fetchWithAuthHeader(
        url,
        {
            method: PUT,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(disruption),
        },
    ).then(response => jsonResponseHandling(response));
};

export const createDisruption = (disruption) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions/`);
    return fetchWithAuthHeader(
        url,
        {
            method: POST,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(disruption),
        },
    ).then(response => jsonResponseHandling(response));
};

export const uploadDisruptionFiles = (disruption, files) => {
    const { disruptionId } = disruption;
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions/${disruptionId}/files`);

    const formData = new FormData();
    map(files, (file, index) => formData.append(`file${index}`, file));

    return fetchWithAuthHeader(
        url,
        {
            method: POST,
            headers: {
                Accept: 'application/json',
            },
            body: formData,
        },
    ).then(response => jsonResponseHandling(response));
};

export const deleteDisruptionFile = (disruption, fileId) => {
    const { disruptionId } = disruption;
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions/${disruptionId}/file/${fileId}`);

    return fetchWithAuthHeader(
        url,
        {
            method: DELETE,
            headers: {
                Accept: 'application/json',
            },
        },
    ).then(response => jsonResponseHandling(response));
};

export const addDiversion = (diversion) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/diversions`);
    return fetchWithAuthHeader(
        url,
        {
            method: POST,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(diversion),
        },
    ).then(response => jsonResponseHandling(response));
};

export const updateDiversion = (diversion) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/diversions/${diversion.diversionId}`);
    return fetchWithAuthHeader(
        url,
        {
            method: PUT,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(diversion),
        },
    ).then(response => jsonResponseHandling(response));
};

export const getDisruptionsByFilters = (filters, { signal, includeFilteredRoutes = true } = {}) => {
    const query = buildDisruptionsQuery(filters);
    const url = appendIncludeFilteredRoutes(apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/disruptions${query}`), includeFilteredRoutes);

    return fetchWithAuthHeader(url, { method: GET, signal })
        .then(response => jsonResponseHandling(response));
};

export const getIncidents = (includeDrafts = false) => fetchWithAuthHeader(apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/incidents?includeDraft=${includeDrafts}`), { method: GET })
    .then(response => jsonResponseHandling(response));

export const createIncident = (incident) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/incidents/`);
    return fetchWithAuthHeader(
        url,
        {
            method: POST,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(incident),
        },
    ).then(response => jsonResponseHandling(response));
};

export const updateIncident = (incident) => {
    const { incidentId } = incident;
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/incidents/${incidentId}`);
    return fetchWithAuthHeader(
        url,
        {
            method: PUT,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(incident),
        },
    ).then(response => jsonResponseHandling(response));
};

export const getIncident = (incidentId) => {
    const url = apiUrl(`${DISRUPTION_MANAGEMENT_PATH}/incidents/${incidentId}`);
    return fetchWithAuthHeader(url, { method: GET })
        .then(response => jsonResponseHandling(response));
};
